//@ts-nocheck
import { getConfig } from "../config/config";
import { checkIsEmpty, uintToJson, getTokenSingleton } from "../helpers";
import { SOCKET_EVENT } from "./constant";
import { isWebsocketFail } from "../main";
const { APP_BASE_CHARTFEED_WS_URL } = getConfig();
let feedSocketRef;
let token = await getTokenSingleton(localStorage.TokenResponseTv);
let localclientCode = localStorage.getItem("ClientCode");
const subscriberList = [];
const scripMap = {};
const publishMessage = (eventType, data, focusScripCode) => {
    if (feedSocketRef != undefined) {
        feedSocketRef.postMessage({
            eventType: eventType,
            data: data,
            focusScripCode: focusScripCode,
        });
    }
};
export const initFeedSocket = () => {
    if (feedSocketRef == undefined) {
        feedSocketRef = new Worker(new URL("websocket.worker.ts", import.meta.url));
        if (window.Worker) {
            let accessToken = token.access_token;
            const swarajWsurl = `${APP_BASE_CHARTFEED_WS_URL}ws?access_token=${accessToken}`;
            publishMessage("CONNECT_SOCKET", {
                wsUrl: swarajWsurl,
                clientCode: localclientCode,
            });
            feedSocketRef.onmessage = (e) => {
                try {
                    if (e.data.networkCheckWebsocketError || e.data.networkCheckWebsocketRetry) {
                        isWebsocketFail();
                    }
                    else if (e.data.marketfeedFail) {
                        sessionStorage.setItem("isConnectionFailed", "true");
                    }
                    else if (e.data.marketfeedSuccess) {
                        sessionStorage.setItem("isConnectionFailed", "false");
                    }
                    else {
                        const eventData = uintToJson(e.data);
                        handleAndDispatchMessage(eventData.eventType, eventData.data);
                    }
                }
                catch (error) {
                    console.error(error);
                }
            };
        }
    }
    else {
        onFocusChange(true);
    }
};
export const subscribeToData = (subscriptionMethod, subscriberName, callBackMethod) => {
    let subsData = subscriberList.find((singleSubData) => {
        if (subscriptionMethod.Method === singleSubData.Method) {
            return singleSubData;
        }
    });
    if (subsData) {
        subsData.MarketFeedData.push(...subscriptionMethod.MarketFeedData);
        // scripMap
        subsData.MarketFeedData = arrayUnique(subsData.MarketFeedData);
    }
    else {
        subsData = subscriptionMethod;
        subscriberList.push(subscriptionMethod);
    }
    subscriptionMethod.MarketFeedData.forEach((singleElement) => {
        if (callBackMethod) {
            const isNew = addSingleScripSubscriber(subscriberName, singleElement, callBackMethod, subscriptionMethod.Method);
        }
    });
    publishMessage("SUBSCRIBE", {
        ...subscriptionMethod,
        subscriberName,
    });
    // }
};
const addSingleScripSubscriber = (subscriberName, marketFeedSingleElement, callBackMethod, methodName) => {
    let scripObj = scripMap[marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode];
    if (scripObj) {
        const subsObj = scripObj.subscribers.find((singleElement) => {
            const isAlreadySubscribed = singleElement.componentName == subscriberName;
            return isAlreadySubscribed;
        });
        if (subsObj) {
            const alreadySubscribedMethod = subsObj.method.find((singleElement) => {
                return singleElement == methodName;
            });
            //Just updating it in case there was rerender.Ideally this component itself will not call again
            subsObj.callback = callBackMethod;
            if (checkIsEmpty(alreadySubscribedMethod)) {
                subsObj.method.push(methodName);
                return true;
            }
            else {
                return false;
            }
        }
        else {
            scripObj.subscribers.push({
                method: [methodName],
                callback: callBackMethod,
                componentName: subscriberName,
            });
            return true;
        }
    }
    else {
        scripObj = {
            subscribers: [
                {
                    method: [methodName],
                    callback: callBackMethod,
                    componentName: subscriberName,
                },
            ],
            data: undefined,
            lastUpdateTime: undefined,
        };
        scripMap[marketFeedSingleElement.Exch +
            marketFeedSingleElement.ExchType +
            marketFeedSingleElement.ScripCode] = scripObj;
        return true;
    }
};
export const unsubscribeDataBySubscriber = (subscriberName, methodName) => {
    publishMessage(SOCKET_EVENT.UNSUBSCRIBE_BY_SUBSCRIBER, {
        subscriberName,
        methodName,
    });
    Object.keys(scripMap).forEach((singleScripKey) => {
        unSubscribeDataByScripKey(subscriberName, singleScripKey, methodName);
    });
};
export const unsubscribeDataByScrip = (subscriberName, marketFeedSingleElement, methodName) => {
    publishMessage(SOCKET_EVENT.UNSUBSCRIBE, {
        subscriberName,
        scripData: marketFeedSingleElement,
        methodName,
    });
    unSubscribeDataByScripKey(subscriberName, getScripKey(marketFeedSingleElement), methodName);
};
const unSubscribeDataByScripKey = (subscriberName, singleScripKey, methodName) => {
    const scripObj = scripMap[singleScripKey];
    if (scripObj) {
        if (checkIsEmpty(methodName)) {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName != subscriberName;
            });
            if (newSubList.length > 0) {
                scripObj.subscribers = newSubList;
            }
            else {
                delete scripMap[singleScripKey];
            }
        }
        else {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName == subscriberName;
            });
            if (newSubList.length > 0) {
                const newMethodList = newSubList[0].method.filter((singleMethod) => {
                    return singleMethod != methodName;
                });
                if (newMethodList.length > 0) {
                    newSubList[0].method = newMethodList;
                }
                else {
                    //Recursive call as we need to remove the subscriber itself
                    unSubscribeDataByScripKey(subscriberName, singleScripKey);
                }
            }
        }
    }
};
const arrayUnique = (array) => {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
            if (a[i].ScripCode == a[j].ScripCode && a[i].Exch == a[j].Exch)
                a.splice(j--, 1);
        }
    }
    return a;
};
const getScripKey = (marketFeedSingleElement) => {
    return (marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode);
};
const handleAndDispatchMessage = (methodName, message) => {
    if (message) {
        if (message.PacketIdentifier && (message === null || message === void 0 ? void 0 : message.PacketIdentifier) == "G") {
            message.Exch = message.Exch ? message.Exch : "N";
            message.ExchType = message.ExchType ? message.ExchType : "D";
        }
        else if (message.Exch == undefined) {
            return;
        }
        const key = message.Exch + message.ExchType + message.Token + "";
        const scripObj = scripMap[key];
        if (scripObj) {
            scripObj.lastUpdateTime = new Date();
            const isDataSubscribed = checkAnddispatchDataUsingCallBack(scripObj, message, methodName);
        }
    }
};
const checkAnddispatchDataUsingCallBack = (scripObj, message, methodName) => {
    let isDataSubscribed = false;
    scripObj.subscribers.forEach((singleSubscriber) => {
        let localSubsribed = false;
        singleSubscriber.method.forEach((singleMethod) => {
            if (singleMethod == methodName) {
                isDataSubscribed = true;
                localSubsribed = true;
            }
        });
        if (localSubsribed && singleSubscriber.callback) {
            singleSubscriber.callback(message);
        }
    });
    return isDataSubscribed;
};
export const onFocusChange = (isWindowFocused, focusScripCode) => {
    publishMessage(SOCKET_EVENT.IS_WINDOW_FOCUSED, isWindowFocused, focusScripCode);
};
export const heartBeatData = (subscriptionMethod, subscriberName, callbackMethod) => {
    return subscribeToData(subscriptionMethod, subscriberName, callbackMethod);
};
